import nativeHookApi from '../native-hook-api'

export function isKlapp(integrator = null) {
  if (integrator) {
    return integrator === 'KLARNA_APP'
  }

  return (
    (window.HPP_SETTINGS && window.HPP_SETTINGS.integrator === 'KLARNA_APP') ||
    nativeHookApi.isSupported()
  )
}
